import React, { useState } from 'react'
import { useProject } from '@/modules/work/projects/context';
import { DRIVE } from "icons";
import { EvtIntegrationInputCard } from "components/project/integration/inputcard";
import { useFolderMutation } from '../../mutation';
import CreateFolderDialog from './input';
import { useDriveData } from './useDriveData';

export default function DriveIntegration({ project_slug }) {

    const { id } = useProject();
    const { driveFolderIds } = useDriveData(id);

    const [showFolderDialog, setShowFolderDialog] = useState(false);
    const { mutateAsync: createFolderMutate, isPending: isCreatingFolder } = useFolderMutation();
    const handleFolderCreation = async () => {
        const payload = {
            id,
        };
        await createFolderMutate({ values: payload });
        setShowFolderDialog(false);
    };

    const hasAny = driveFolderIds.length > 0

    return (
        <div>
            <EvtIntegrationInputCard
                title={"Drive"}
                icon={DRIVE}
                type={"Folder"}
                onClick={() => setShowFolderDialog(true)}
                disabled={hasAny}
            />
            <CreateFolderDialog
                open={showFolderDialog}
                onOpenChange={setShowFolderDialog}
                onConfirm={handleFolderCreation}
                isLoading={isCreatingFolder}
                project={project_slug}
            />
        </div>
    )
}